var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeftSmallOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2810_353",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3,
    width: 6,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63495 8.33865C5.64126 8.34573 5.6478 8.35267 5.65459 8.35946C5.66029 8.36517 5.66609 8.37072 5.672 8.37609L9.64999 12.3541C9.84525 12.5494 10.1616 12.5492 10.3566 12.3536C10.5515 12.158 10.5513 11.8412 10.356 11.646L6.71452 8.00441L10.3537 4.35381C10.5486 4.15824 10.5485 3.84128 10.3534 3.64587C10.1583 3.45045 9.84206 3.45058 9.6471 3.64615L5.73104 7.57455C5.7009 7.59383 5.67238 7.61666 5.64607 7.64305C5.45506 7.83464 5.45141 8.14262 5.63495 8.33865Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2810_353)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftSmallOutlined);
export default __webpack_public_path__ + "static/media/chevron-left-small-outlined.8d87102f08bfcc3c2aa4f4619445fbd4.svg";
export { ForwardRef as ReactComponent };